import type { FaireProductEntity } from "../../entity_types/product";

export const p_xpw5yjuq4e: FaireProductEntity = {
  token: "p_xpw5yjuq4e",
  type: "product",
  name: "Rectangular Mahjong Tile Cluster Stud Earrings",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/da78a6d8e71f20b5fb6f6acc82be8718c1307183ffb834074e2113ec3a041778.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa8a2598f2a0f64dd659e2ada2623d92916a293edaa974dd9d02587c5a4a30bc.jpeg",
    "https://cdn.faire.com/fastly/1df66f1079dca75b5c21576942994e3d6eb99c970fbcfc33929095cac6b5846f.jpeg",
    "https://cdn.faire.com/fastly/ae12e24737a470f97c9763f6249fbfa90bf2c2c859c2bc3138e1c59be69298b5.jpeg",
    "https://cdn.faire.com/fastly/93ee2c293ebd26d27e6cba3bc4cab21d162615c7531804add2c84e428eff5ac3.jpeg",
    "https://cdn.faire.com/fastly/6200d72bd6943738bd9f7f0e04753db99f38a5846ad66fe1c85d2c8461f65483.jpeg",
    "https://cdn.faire.com/fastly/adc8adbf86610e63657cb7350e3231f5d85915f10aad7cb83127356765e92240.jpeg",
  ],
  priceDollars: 3.58,
  description:
    'Size : 0.7" X 0.8"\r\nPost Back\r\nExpress your unique style with these mahjong print statement earrings featuring an eye-catching artistic design. Perfect for adding personality to casual outfits, special occasions, and everyday looks, these lightweight fashion earrings bring a creative touch to any jewelry collection. A thoughtful gift choice for trend-conscious shoppers who love distinctive accessories.\nLead and Nickel Compliant\n',
  tags: [],
  msrpDollars: 7.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:40.292Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
